const STATE = {
  mdmModel: {
    data: null,
  },
};

export default STATE;
